module.exports = __webpack_public_path__ + "static/media/Disburse_Phy_MC wATM Short Form_STD-MPC.facb93ad.pdf";